import { Button } from '@design-system/button';
import { Typography } from '@design-system/typography';
import React, { FC, useMemo } from 'react';

import TMPLinkWrap from '~/components/TMPLinkWrap';

import { ArticleListingProps } from '../models';

export const ArticleListing: FC<ArticleListingProps> = ({
  items = [],
  maxVisibleItems,
  setTabValue,
  tabNumber,
  moreButtonText,
}) => {
  const visibleItems = useMemo(() => {
    if (maxVisibleItems) {
      return items.slice(0, maxVisibleItems);
    }

    return items;
  }, [maxVisibleItems, items]);

  if (!items.length) {
    return null;
  }

  return (
    <>
      {visibleItems.map((item) => (
        <div className="search-result__article-listing" key={item.url}>
          <TMPLinkWrap variant="subtle" href={item.url}>
            <Typography
              content={item.title}
              tag="h2"
              variant="headline"
              size="s"
              align="start"
              weight="regular"
              className="search-result__article-title"
            />
          </TMPLinkWrap>
          <Typography
            content={item.description}
            tag="p"
            variant="body"
            size="m"
            align="start"
            className="search-result__article-description"
          />
        </div>
      ))}
      <div className="search-result__button-wrapper">
        <Button variant="secondary" onClick={() => setTabValue(tabNumber)}>
          {moreButtonText}
        </Button>
      </div>
    </>
  );
};

export default ArticleListing;
